// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"4176d69c","726":"d0921daa","785":"e8f18f0e"}[chunkId] + ".chunk.js";
};